import React from "react";
import { Skeleton } from "@fluentui/react-northstar";
import Card from "../Card/Card";
import { Grid } from "../Grid/Grid";

/** Carte squelette (premier chargement d'une section) */
export const SkeletonCard = ({ lines = 2 }) => (
    <Card>
        <Skeleton animation="pulse">
            <Skeleton.Line width="60%" height="14px" />
            {Array.from({ length: lines }, (_, i) => (
                <Skeleton.Line key={`line-${i}`} width="90%" height="22px" />
            ))}
        </Skeleton>
    </Card>
);

/**
 * Squelette d'une section : `rows` = liste de grilles,
 * chaque grille = { cols, cards: [nb de lignes par carte] }
 */
const SectionSkeleton = ({ rows }) => (
    <>
        {rows.map((row, r) => (
            <Grid key={`row-${r}`} cols={row.cols} $mb={r < rows.length - 1}>
                {row.cards.map((lines, c) => (
                    <SkeletonCard key={`card-${r}-${c}`} lines={lines} />
                ))}
            </Grid>
        ))}
    </>
);

export default SectionSkeleton;
